var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-heading',{staticClass:"bg-orange-4",attrs:{"title":"Real Estate Search Parcel Information","email":"auditor@jeffersoncountyoh.com","phone":"(740) 283-8511"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }